// test78
(78 && 0);
